import { render } from "./pnc_prescriptions.vue?vue&type=template&id=12a4eb27&scoped=true"
import script from "./pnc_prescriptions.vue?vue&type=script&lang=js"
export * from "./pnc_prescriptions.vue?vue&type=script&lang=js"

import "./pnc_prescriptions.vue?vue&type=style&index=0&id=12a4eb27&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12a4eb27"]])

export default __exports__